// extracted by mini-css-extract-plugin
export default {"consent":"CookieModal_consent__alQtB","consentGrid":"CookieModal_consentGrid__gp5s+","buttonGrid":"CookieModal_buttonGrid__h7hxl","consentModal":"CookieModal_consentModal__waQ-9"};